"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _CreativeLayer2 = _interopRequireDefault(require("./CreativeLayer"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _isEmptyString = _interopRequireDefault(require("../../utils/object/isEmptyString"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var MediaCreativeLayer = /*#__PURE__*/function (_CreativeLayer) {
  (0, _inherits2["default"])(MediaCreativeLayer, _CreativeLayer);

  var _super = _createSuper(MediaCreativeLayer);

  function MediaCreativeLayer() {
    (0, _classCallCheck2["default"])(this, MediaCreativeLayer);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MediaCreativeLayer, [{
    key: "internalGenerateContentStoreId",
    value: function internalGenerateContentStoreId() {
      if ((0, _isNil["default"])(this._media) || (0, _isEmptyString["default"])(this._media.serverId)) return (0, _get2["default"])((0, _getPrototypeOf2["default"])(MediaCreativeLayer.prototype), "internalGenerateContentStoreId", this).call(this);
      return this._media.serverId;
    }
  }]);
  return MediaCreativeLayer;
}(_CreativeLayer2["default"]);

exports["default"] = MediaCreativeLayer;